import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress, Grid, Typography, Card, CardContent, Divider } from '@material-ui/core'

import PinDropIcon from '@material-ui/icons/PinDrop'
import ExploreIcon from '@material-ui/icons/Explore'
import LocationCityIcon from '@material-ui/icons/LocationCity'

import { Page, Header, ObjetoAvatar, SecaoGenerica } from 'components'
import { CardExameSolicitado } from 'components/Cards/CardExameSolicitado'
import { CardVestigio } from 'components/Cards/CardVestigio'
import { CardCadaver } from 'components/Cards/CardCadaver'
import { CardCaso } from 'components/Cards/CardCaso'
import { ListaInformacoes } from 'views/Informacao/ListaInformacoes'

import { MenuAcoes } from './components/MenuAcoes/MenuAcoes'
import { useLocalDetalhe } from './hooks/useLocalDetalhe'
import useStyles from './Local.styles'

export const Local = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    local,
    carregando,
    handleClickExameSolicitado,
    handleClickVestigio,
    handleClickCadaver,
    handleClickCaso,
  } = useLocalDetalhe(props)

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header titulo={route.secao} overline={route.secao} />

      {carregando ? (
        <div className={classes.loadingContainer}>
          <CircularProgress size={45} />
        </div>
      ) : (
        <div className={classes.detailsContainer}>
          {/* Card de Informações Principais no Topo (Mesmo padrão de Vestígios/Cadáveres) */}
          <Card className={classes.headerCard}>
            <CardContent style={{ padding: '24px' }}>
              <Grid container spacing={3} alignItems="center" justifyContent="space-between">
                <Grid item xs={12} sm={6} md={7} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                  <ObjetoAvatar tipo="LOCAL" />
                  <Typography variant="h3" className={classes.caseTitle}>
                    {local.rua ? `${local.rua.toUpperCase()}, ${local.numero || 'S/N'}${local.bairro ? ` - ${local.bairro.toUpperCase()}` : ''}` : 'LOCAL'}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  {local.id && (
                    <MenuAcoes local={local} />
                  )}
                </Grid>
              </Grid>

              <Divider style={{ margin: '20px 0 24px 0' }} />

              <Typography variant="subtitle1" className={classes.caseSubtitle} style={{ marginTop: 0, marginBottom: '24px' }}>
                {local.complemento ? `COMPLEMENTO: ${local.complemento.toUpperCase()}` : 'SEM COMPLEMENTO INFORMADO'}
              </Typography>

              <Grid container spacing={3} className={classes.metaGrid} alignItems="stretch">
                <Grid item xs={12} sm={6} md={3}>
                  <div className={classes.metaItem}>
                    <LocationCityIcon className={classes.metaIcon} />
                    <div className={classes.metaTextContainer}>
                      <Typography className={classes.metaLabel}>CIDADE / UF</Typography>
                      <Typography className={classes.metaValue}>
                        {local.cidade ? `${local.cidade.toUpperCase()} - ${local.estado?.toUpperCase() || ''}` : '-'}
                      </Typography>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={classes.metaItem}>
                    <PinDropIcon className={classes.metaIcon} />
                    <div className={classes.metaTextContainer}>
                      <Typography className={classes.metaLabel}>CEP</Typography>
                      <Typography className={classes.metaValue}>
                        {local.cep || '-'}
                      </Typography>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={classes.metaItem}>
                    <ExploreIcon className={classes.metaIcon} />
                    <div className={classes.metaTextContainer}>
                      <Typography className={classes.metaLabel}>LATITUDE (GPS)</Typography>
                      <Typography className={classes.metaValue}>
                        {local.latitudeGps || '-'}
                      </Typography>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={classes.metaItem}>
                    <ExploreIcon className={classes.metaIcon} />
                    <div className={classes.metaTextContainer}>
                      <Typography className={classes.metaLabel}>LONGITUDE (GPS)</Typography>
                      <Typography className={classes.metaValue}>
                        {local.longitudeGps || '-'}
                      </Typography>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Informações Adicionadas */}
          {local.id && (
            <SecaoGenerica titulo="Informações Adicionadas">
              <Grid item xs={12}>
                <ListaInformacoes tipo="local" id={local.id} />
              </Grid>
            </SecaoGenerica>
          )}

          {/* Exames Solicitados */}
          <SecaoGenerica titulo="Exames Solicitados">
            {local.exSols && local.exSols.length > 0 ? (
              <div className={classes.cardsGrid}>
                {local.exSols.map((exameSolicitado) => (
                  <div key={exameSolicitado.id} className={classes.cardWrapper}>
                    <CardExameSolicitado
                      exameSolicitado={exameSolicitado}
                      handleClick={handleClickExameSolicitado}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <Grid container className={classes.fieldGroup} justifyContent="center" alignItems="center" style={{ padding: '50px' }}>
                <Typography variant="body2" color="textSecondary">Nenhum exame solicitado</Typography>
              </Grid>
            )}
          </SecaoGenerica>

          {/* Objetos Associados */}
          <SecaoGenerica titulo="Objetos Associados">
            {(local.vestOrigs && local.vestOrigs.length > 0) || (local.cadavsOrig && local.cadavsOrig.length > 0) ? (
              <div className={classes.cardsGrid}>
                {local.vestOrigs?.map((vestigio) => (
                  <div key={vestigio.id} className={classes.cardWrapper}>
                    <CardVestigio vestigio={vestigio} handleClick={handleClickVestigio} />
                  </div>
                ))}
                {local.cadavsOrig?.map((cadaver) => (
                  <div key={cadaver.id} className={classes.cardWrapper}>
                    <CardCadaver cadaver={cadaver} handleClick={handleClickCadaver} />
                  </div>
                ))}
              </div>
            ) : (
              <div className={classes.noDataContainer}>
                <Typography className={classes.noDataText}>Nenhum objeto associado ao local</Typography>
              </div>
            )}
          </SecaoGenerica>

          {/* Caso Associado */}
          {local.caso && (
            <SecaoGenerica titulo="Caso Associado">
              <div className={classes.cardWrapper}>
                <CardCaso caso={local.caso} handleClick={handleClickCaso} />
              </div>
            </SecaoGenerica>
          )}
        </div>
      )}
    </Page>
  )
}

Local.propTypes = {
  route: PropTypes.object.isRequired,
}
